var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VpanelModuleConfigList',{attrs:{"module-configs":_vm.moduleSettings,"form-id":"update-marketing-message-module-setting"},on:{"submit-form":_vm.submitSettingsForm,"update-config-value":_vm.updateModuleSetting}})}
var staticRenderFns = []

export { render, staticRenderFns }